import React from "react";

const Twitter = ({ width = 30 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width={width}>
    <path d="M5.13 81.61a41.13 41.13 0 0 0 25.46-8.77A20.53 20.53 0 0 1 11.44 58.6a20.35 20.35 0 0 0 9.25-.35A20.53 20.53 0 0 1 4.26 38.13v-.25a20.39 20.39 0 0 0 9.29 2.53A20.53 20.53 0 0 1 7.23 13a58.14 58.14 0 0 0 42.22 21.49A20.51 20.51 0 0 1 84.33 15.8a41 41 0 0 0 13-5 20.58 20.58 0 0 1-9 11.38A40.84 40.84 0 0 0 100.1 19a41.58 41.58 0 0 1-10.23 10.59v2.65c0 27.1-20.63 58.34-58.34 58.34A58.06 58.06 0 0 1 .1 81.37a43.26 43.26 0 0 0 5.03.24z" />
  </svg>
);

export default Twitter;
